import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, ErrorService, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { AccessService } from '../shared/access.service';
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';

@Component({
  selector: 'app-access-list',
  // styleUrls: ['table-basic-example.css'],
  templateUrl: 'access-list.component.html',
})

export class AccessListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() data: any;
  @Input() titlePage: string;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[];
  dataSource: GridDataSource;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(private loaderService: LoaderService, private accessService: AccessService,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.pageSize = CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.msgErrorGet = 'Error al listar los accesos';
    this.displayedColumns = ['AccessID', 'Name', 'Path', 'Description', 'Status'];
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
  }

  handleRowClick(row: any) {
    this.selectedRowIndex = row.ID;
    this.data.access = { ID: row.ID, Name: row.Name };
    this.changeEvent({ evento: EVENTO.consultar, data: this.data });
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    // this.paginator.length = this.pageEvent.length;
    // this.paginator.pageIndex = this.pageEvent.pageIndex;
    // this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscarAccess(data.filtro, this.sectionBarComponent.aplicacionID, this.sectionBarComponent.moduleID);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    this.listarPorAccess(this.sectionBarComponent.filtro, this.sectionBarComponent.aplicacionID, this.sectionBarComponent.moduleID);
  }

  buscarAccess(filtro: string, aplicacionID: number, moduleID: number) {
    this.clearMatPaginator();
    this.listarPorAccess(filtro, aplicacionID,moduleID);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  private listarPorAccess(filtro: string, pAplicacionID: number, pModuleID: number): void {
    this.loaderService.show();
    this.accessService.listarPorAccess(filtro, pAplicacionID, pModuleID, this.pageEvent.pageIndex, this.pageEvent.pageSize)
      .subscribe(res => {
        this.dataSource = new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
        this.pageEvent.length = res.length;
        this.setMatPaginator();
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

